import { breakpoint, colors, fontFamily, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  footer: css({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    marginBottom: 0,
    paddingTop: spacing.extraLarge,
    paddingBottom: '60px',
    paddingRight: spacing.large,
    paddingLeft: spacing.large,
    [mediaQueryHelper(breakpoint.desktop)]: {
      width: '1000px',
      flexDirection: 'row',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingRight: 0,
      paddingLeft: 0,
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '1000px',
      flexDirection: 'row',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingRight: 0,
      paddingLeft: 0,
    },
  }),
  logo: css({
    paddingBottom: '29px',
    [mediaQueryHelper(breakpoint.tablet)]: {
      paddingBottom: 0,
    },
  }),
  listHeading: css({
    fontFamily: fontFamily.heading,
    color: colors.cornflowerBlue,
    fontSize: fontSize.default,
    fontWeight: fontWeight.bold,
  }),
  listItemLink: css({
    borderStyle: 'none',
    fontFamily: fontFamily.body,
    color: colors.jumbo,
    fontWeight: fontWeight.regular,
    textDecoration: 'none',
    fontSize: fontSize.default,
    lineHeight: '22px',
    '&:hover': {
      color: colors.cornflowerBlue,
    },
    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),
  list: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginBottom: '10px',
    '& > li': {
      listStyle: 'none',
      paddingTop: '10px',
      paddingBottom: '10px',
      width: '100%',
      [mediaQueryHelper(breakpoint.tablet)]: {
        paddingTop: '6px',
        paddingBottom: '6px',
      },
    },
    '& > li:first-child': {
      paddingBottom: 0,
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      '& > li:first-child': {
        paddingBottom: 0,
      },
    },
  }),
  socialIconContainer: css({
    paddingTop: '5px',
    display: 'flex',
    flexDirection: 'row',
    '& a': {
      paddingRight: '10px',
    },
    '& a:last-child': {
      paddingRight: '0',
    },
  }),
  socialIcon: css({
    borderStyle: 'none',
    '& img': {
      width: '45px',
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      '& img': {
        width: '25px',
      },
    },
  }),
  columnWide: css({
    width: '100%',
    paddingRight: 0,
    paddingLeft: '10px',
    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '25%',
      paddingRight: '10px',
      paddingLeft: spacing.large,
    },
  }),
  columnNarrow: css({
    width: '100%',
    paddingRight: 0,
    paddingLeft: '10px',
    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '16.66%',
      paddingLeft: '10px',
      paddingRight: '10px',
    },
  }),
  policyRoot: css({
    textAlign: 'center',
  }),
  policyContainer: css({
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
    marginBottom: 0,
    paddingTop: spacing.extraLarge,
    paddingBottom: spacing.extraLarge,
    borderTop: `1px solid ${colors.geyser}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& a': {
      paddingRight: spacing.large,
    },
    '& a:last-child': {
      paddingRight: '0',
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      maxWidth: '940px',
    },
  }),
}

export default styles
